<template>
  <div></div>
</template>

<script>
  export default {
    name: 'AppDownload',
    computed: {
      iOS () {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent) && !/GoNative/i.test(navigator.userAgent);
      },
      Android () {
        return /Android/i.test(navigator.userAgent) && !/GoNative/i.test(navigator.userAgent);
      }
    },
    mounted () {
      let url, store;

      if (this.iOS) {
        url   = 'https://apps.apple.com/us/app/jagdnews/id1483200647?l=de&ls=1';
        store = 'im App Store';
      }

      if (this.Android) {
        url   = 'https://play.google.com/store/apps/details?id=de.jagdnews.app';
        store = 'bei Google Play';
      }

      if (url) {
        const msg = this.$createElement(
          'a',
          {
            class: 'text-dark',
            attrs: { href: url }
          },
          [
            this.$createElement(
              'fa-icon',
              {
                props: { icon: ['fal', 'arrow-to-bottom'], size: 'lg' },
                class: 'float-right'
              }
            ),
            'Hier ' + store + ' herunterladen'
          ]
        );

        this.$bvToast.toast(msg, {
          title: 'Kennst du schon die Jagdnews App?',
          variant: 'success',
          noAutoHide: true,
          toaster: 'b-toaster-bottom-center'
        });
      }
    }
  };
</script>
